export class coordinate{

  latitude:number;
  longitude:number;
  height:number;

  constructor(latitude:number, longitude:number, height:number){
    this.latitude = latitude;
    this.longitude = longitude;
    this.height = height;
  }
}
